import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=4b6c37fa&scoped=true&"
import script from "./partner.vue?vue&type=script&lang=js&"
export * from "./partner.vue?vue&type=script&lang=js&"
import style0 from "./partner.vue?vue&type=style&index=0&id=4b6c37fa&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c37fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6c37fa')) {
      api.createRecord('4b6c37fa', component.options)
    } else {
      api.reload('4b6c37fa', component.options)
    }
    module.hot.accept("./partner.vue?vue&type=template&id=4b6c37fa&scoped=true&", function () {
      api.rerender('4b6c37fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/lingyue-tech/index/component/partner/partner.vue"
export default component.exports